import { render, staticRenderFns } from "./Shaka.vue?vue&type=template&id=0191eb78&scoped=true"
import script from "./Shaka.vue?vue&type=script&lang=js"
export * from "./Shaka.vue?vue&type=script&lang=js"
import style0 from "./Shaka.vue?vue&type=style&index=0&id=0191eb78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0191eb78",
  null
  
)

export default component.exports